module.exports = __webpack_public_path__ + "img/arrow-main.b06c0bdf.svg";